import i18n from '../../src/translation'


class Utils {

  // static Capitalize = (str) => {
	// 	let string = str.toLowerCase()
	// 	return string.charAt(0).toUpperCase() + string.slice(1);
  // }


	// static getCurrentDate(separator=' '){

	// 	let newDate = new Date()
	// 	let date = (newDate.getDate() < 10) ? `0${newDate.getDate()}` : `${newDate.getDate()}`;
	// 	let month = newDate.toLocaleString("en-US", { month: "short" })

	// 	return {date, month}
	// }


  // static filterArray(list, type, month, municipality, current) {

  //   let data = list

	// 	let newDate = new Date()
	// 	let today = new Date().getTime()
	// 	let date = (newDate.getDate() < 10) ? `0${newDate.getDate()}` : `${newDate.getDate()}`;
	// 	let months = newDate.toLocaleString("en-US", { month: "short" })


	// 	if (type === "allEvents" &&
	// 		(month === "allMonths" || month === "Month") &&
	// 		municipality === "allMunicipality" &&
	// 		current === "Current") {
	// 		return data
	// 	}

	// 	else {
	// 		  let array_current = [];
	// 		  data = list.filter(item => {

	// 				let array_type = (type !== "allEvents") ? (item['type'] === type) : true
	// 				let array_month = (month !== "allMonths") ? (item['month_code'] === month) : true
	// 				let array_municipality = (municipality !== "allMunicipality") ? (item.municipality===municipality) : true

	// 				switch (current) {
	// 					case 'cur':
	// 						array_current = ( item['day'] === date && item['month_code'] === months ); break;
	// 					case 'att':
	// 						array_current = today < item['day_code']; break;
	// 					case 'old':
	// 						array_current = today > item['day_code']; break;
	// 					default:
							
	// 				}

	// 				return (array_type && array_month && array_municipality && array_current)
	// 			})
	// 	}
	// 	return data
  // }
  

	static filterSearchArray(list, routesSelected, environmentSelected, historySelected, eventsSelected, municipalitiesSelected ) {
	
		let ListArray = []
		let ListArray2 = []

		// console.log('filterSearchArray -----------')
		// console.log('list -----------', list)
		// console.log('routesSelected -----------', routesSelected)
		// console.log('environmentSelected -----------', environmentSelected)
		// console.log('historySelected -----------', historySelected)
		// console.log('eventsSelected -----------', eventsSelected)
		// console.log('municipalitiesSelected -----------', municipalitiesSelected)

		if (routesSelected.length === 0 && environmentSelected.length === 0  && historySelected.length === 0 && eventsSelected.length === 0 && municipalitiesSelected.length === 0){	
			return list
		}


		// if (searchSelected.length === 0 && municipalitiesSelected.length !== 0){	
		// 	ListArray = list
		// }
	
		if (routesSelected.length !== 0){	
			for (let i in routesSelected[0]){
				// list.map(item => (item.categoryName === routesSelected[0][i]) && ListArray.push(item))

				list.map(item => {
						if (item.type == "Route")
							item.categoryName === routesSelected[0][i] && ListArray.push(item)
						else
							item.typesOfRoute.includes(routesSelected[0][i]) && ListArray.push(item)
					}
				)

			}
		}


		if (environmentSelected.length !== 0) 
			for (let i in environmentSelected[0]) {
				list.map(item => (item.category_id === environmentSelected[0][i]) && ListArray.push(item))
			}

		if (historySelected.length !== 0) 
			for (let i in historySelected[0]) {
				list.map(item => (item.category_id === historySelected[0][i]) && ListArray.push(item))
			}
		
		

		if (eventsSelected.length !== 0) 
			for (let i in eventsSelected[0]) {
					list.map(item => item.categoryName === eventsSelected[0][i] && ListArray.push(item))
			}
		
		
		
		
		
		// console.log('ListArray -----------', ListArray)
		if (municipalitiesSelected.length !== 0) {

			
			if (routesSelected.length === 0 && environmentSelected.length === 0  && historySelected.length === 0 && eventsSelected.length === 0)
					 ListArray = list

			for (let i in municipalitiesSelected[0]){
				ListArray.map(item => (item.municipality === municipalitiesSelected[0][i]) && ListArray2.push(item))
			}

			ListArray = ListArray2
		}

		
		return ListArray

  }







  static filterPoisesArray(list, environmentSelected, historySelected, municipalitiesSelected, selectSort) {
	
		let ListArray = []
		let ListArray2 = []

		


		if (environmentSelected.length == 0 && historySelected.length == 0 && municipalitiesSelected.length == 0){	
			if(selectSort == 'rate')
					list = [...list].sort((a, b) => a.rate > b.rate ? -1 : 1);
					return list
		}
	

		if (environmentSelected.length !== 0) {
			for (let i in environmentSelected[0]) {
				



				if (environmentSelected[0][i] == 21) {
					
					if (i18n.language == 'gr'){
						ListArray.push({
								"id": "1_358",
								"image": "https://chaniaregion-admin.repository.gr/files/asset/f24e62b0f44950f0c8a4a06255374a3e2446e1d4.jpg",
								"municipality": "Κισσάμου",
								"title": "Τηγάνι - Λιμνοθάλασσα Μπάλου",
								"lat": "35.58001516779292",
								"lng": "23.588629548652445",
								"rate": 4.7,
								"vote": 1,
								"category_id": 22,
								"category": "Παραλία, Περιοχές NATURA",
								"text": "Η λιμνοθάλασσα του Μπάλου βρίσκεται στο βορειοδυτικό άκρο της Κρήτης, σε απόσταση 17 χιλιομέτρων από το Καστέλι Κισάμου. Πρόκειται για μία φημισμένη παραλία, εξωτικής ομορφιάς, με μεγάλη επισκεψιμότητα το καλοκαίρι. Τα νερά της θάλασσας σχηματίζουν μία μεγάλη λιμνοθάλασσα, καθώς παγιδεύονται ανάμεσα στη χερσόνησο της Γραμβούσας και τη χερσόνησο Τηγάνι, η οποία ενώνεται με την υπόλοιπη Κρήτη με μια λεπτή λωρίδα γης. Η παραλία έχει κατάλευκη αμμουδιά και σε κάποια σημεία ροζ από τα σπασμένα κοχύλια, ενώ τα γαλαζοπράσινα νερά της είναι πολύ ρηχά, με εξαίρεση στα δεξιά του κόλπου, όπου βαθαίνουν κάπως. Ο Μπάλος ανήκει στο δίκτυο προστασίας Natura 2000, λόγω του οικολογικού του ενδιαφέροντος. Στις αμμοθίνες της παραλίας υπάρχει ιδιαίτερη βλάστηση, όπως ρείκι,  θυμάρι, σχοίνος, το κρίνο της παραλίας, το προστατευόμενο είδος κενταύρια η νανώδης κ.ά. Στο τηγάνι, επίσης, φυτρώνει το γαϊδουράγκαθο. Η πρόσβαση στην παραλία μπορεί να γίνει μέχρι ένα σημείο με αυτοκίνητο και στη συνέχεια περπατώντας σε ένα μονοπάτι που βρίσκεται στις πλαγιές του όρους Γεροσκίνος, στη χερσόνησο της Γραμβούσας. Όποιος κάνει αυτή τη διαδρομή θα έχει την ευκαιρία να απολαύσει και να φωτογραφίσει το μαγευτικό τοπίο που απλώνεται μπροστά του. Εναλλακτικά, η πρόσβαση γίνεται με καραβάκι από το Καστέλι.<p><strong><i>Μέσο Πρόσβασης: </i></strong><br>Πεζοπορία, Δια θαλάσσης</p><p><strong><i>Πρόσβαση ΑμεΑ: </i></strong><br>Όχι</p>",
								"featured": 1
						})
						ListArray.push({
							"id": "1_359",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/d633517c607fd2bd6bd443f9262a48145dd99241.jpg",
							"municipality": "Κισσάμου",
							"title": "Φαλάσσαρνα",
							"lat": 35.50043921530942,
							"lng": 23.57863594291497,
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Παραλία, Περιοχές NATURA",
							"text": "Τα Φαλάσαρνα είναι μία φημισμένη παραλία που βρίσκεται σε απόσταση 17 χιλιομέτρων από το Καστέλι Κισάμου. Η κεντρική παραλία μήκους ενός χιλιομέτρου ονομάζεται Παχιά Άμμος και είναι οργανωμένη. Έχει ανοιχτόχρωμη αμμουδιά και τυρκουάζ νερά. Υπάρχει και μία άλλη παραλία στα 800 μέτρα μήκος, πιο ήσυχη που κοντά της βρίσκεται το εξωκλήσι της Αγίας Παρασκευής και μία πηγή. Βορειότερα βρίσκονται δύο άλλες παραλίες, το Λιβάδι που έχει βράχια στον βυθό και η άλλη με βότσαλα κοντά στο λιμανάκι. Η περιοχή έχει ενταχθεί στο πρόγραμμα Natura 2000, λόγω της σπάνιας χλωρίδας και πανίδας. Στο βόρειο τμήμα της παραλίας σώζονται ερείπια από την αυτόνομη ελληνορωμαϊκή πόλη-κράτος Φαλάσαρνα που υπήρχε στη σημερινή θέση Κουτρί, η οποία είχε το δικό της νόμισμα. Η Φαλάσαρνα πήρε το όνομά της από τη μυθολογική νύμφη Φαλασάρνη και ήταν το λιμάνι της Πολυρρήνιας. Το λιμάνι είχε γύρω του τείχη και η σύνδεσή του με τη θάλασσα γινόταν μέσω μιας διώρυγας. Η Φαλάσαρνα πιστεύεται ότι καταστράφηκε από τον Ρωμαίο στρατηγό Μέτελλο, λόγω της αντίστασης που προέβαλαν. Σήμερα ένα μέρος της πόλης είναι βυθισμένο στη θάλασσα και τα ερείπια του λιμανιού βρίσκονται στην ξηρά, αφού η ακτή ανυψώθηκε γύρω στα 6 μέτρα, πιθανόν λόγω του σεισμού που έγινε το 365 μ.Χ.<p><strong><i>Μέσο Πρόσβασης: </i></strong><br>Αυτοκινητόδρομος, Δια θαλάσσης</p><p><strong><i>Πρόσβαση ΑμεΑ: </i></strong><br>Όχι</p>",
							"featured": 0
						})
					}
					if (i18n.language == 'en'){				
						ListArray.push({
							"id": "1_358",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/f24e62b0f44950f0c8a4a06255374a3e2446e1d4.jpg",
							"municipality": "Κισσάμου",
							"title": "Tigani - Balos Lagoon",
							"lat": "35.58001516779292",
							"lng": "23.588629548652445",
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Beaches, NATURA Areas",
							"text": "The lagoon of Balos is located at the northwestern tip of Crete, at a distance of 17 km from Kastelli Kissamos. It is a famous beach of exotic beauty, overcrowding in summer. The sea waters form a large lagoon trapped between the Gramvousa peninsula and the Tigani peninsula, which joins the rest of Crete with a thin strip of land. The beach has white sand and pink from the broken shells in places, while its turquoise waters are very shallow, except for the right side of the bay, where they deepen somewhat. Balos belongs to the Natura 2000 protection network due to its ecological interest. There is unique vegetation in the beach's dunes, such as heather, thyme, gorse, sea daffodil, the protected species of Centaurea nana, etc. The thistle also grows in the Tigani peninsula. The beach is accessible by car up to a point and then on foot on a path located on the slopes of Mount Geroskinos, on the Gramvousa peninsula. Anyone who takes this route will have the opportunity to enjoy and photograph the enchanting landscape that stretches in front of him. Alternatively, the beach is accessible by boat from Kastelli.<p><strong><i>Means of access: </i></strong><br>Hiking, By sea</p><p><strong><i>Disabled access: </i></strong><br>No</p>",
							"featured": 1
						})
						ListArray.push({
							"id": "1_359",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/d633517c607fd2bd6bd443f9262a48145dd99241.jpg",
							"municipality": "Κισσάμου",
							"title": "Falassarna",
							"lat": 35.50043921530942,
							"lng": 23.57863594291497,
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Beaches, NATURA Areas",
							"text": "Falasarna is a famous beach located 17 km from Kastelli Kissamos. The central beach, called Pachia Ammos, is one kilometer long and organized. It has a light-colored sandy beach and turquoise waters. There is another more peaceful beach 800 meters long, close to the chapel of Saint Paraskevi, and a fountain. One will find two more beaches to the north, Livadi with rocks at the sea bottom and another pebbly near the port. The area has been included in the Natura 2000 program due to the rare flora and fauna. In the northern part of the beach, ruins are preserved from the autonomous Greco-Roman city-state Falassarna that existed in the present site of Koutri and had its own currency minted. Falassarna was named after the mythological nymph Falassarna and was the city-port of Polyrrenia. The port had walls around it, and its connection to the sea was made through a canal. Falassarna is believed to have been destroyed by the Roman general Metellus because of the resistance they put up. Today a part of the city is submerged in the sea, and the ruins of the port are on land since the coast was raised to about 6 meters, probably due to the earthquake that occurred in 365 AD.<p><strong><i>Means of access: </i></strong><br>Motorway, By sea</p><p><strong><i>Disabled access: </i></strong><br>No</p>",
							"featured": 0
						})
					}
					if (i18n.language == 'de'){			
						ListArray.push({
							"id": "1_358",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/f24e62b0f44950f0c8a4a06255374a3e2446e1d4.jpg",
							"municipality": "Κισσάμου",
							"title": "Tigani-Lagune Balos",
							"lat": "35.58001516779292",
							"lng": "23.588629548652445",
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Strände, NATURA-Gebiete",
							"text": "Die Lagune von Balos liegt an der nordwestlichen Spitze Kretas, 17 km von Kasteli Kissamos entfernt. Dies ist ein berühmter Strand von exotischer Schönheit mit viel Verkehr im Sommer. Das Meerwasser bildet eine große Lagune, da es zwischen der Gramvousa-Halbinsel und der Tigani-Halbinsel eingeschlossen ist, die den Rest Kretas mit einem dünnen Landstreifen verbindet. Der Strand hat weißen Sand und an einigen Stellen rosa von den zerbrochenen Muscheln, während sein türkisfarbenes Wasser sehr flach ist, mit Ausnahme der rechten Seite der Bucht, wo es etwas tiefer wird. Balos gehört aufgrund seines ökologischen Interesses zum Schutznetz Natura 2000. In den Sanddünen des Strandes gibt es eine besondere Vegetation, wie Heidekraut, Thymian, Tau, die Strandlilie, die geschützten Arten Zentauren oder Zwerg usw. Auch die Distel wächst in Tigani. Der Strand kann bis zu einem gewissen Punkt mit dem Auto und dann zu Fuß auf einem Pfad an den Hängen des Berges Geroskinos auf der Halbinsel Gramvousa erreicht werden. Jeder, der diese Route macht, hat die Möglichkeit, die bezaubernde Landschaft, die sich vor ihm erstreckt, zu genießen und zu fotografieren. Alternativ ist der Zugang mit dem Boot von Kasteli aus möglich.<p><strong><i>Zugang für Behinderte:</i></strong><br>Wandern, Auf dem Seeweg</p><p><strong><i>Zugangsmittel:</i></strong><br>Nein</p>",
							"featured": 1
						})
						ListArray.push({
							"id": "1_359",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/d633517c607fd2bd6bd443f9262a48145dd99241.jpg",
							"municipality": "Κισσάμου",
							"title": "Falasarna",
							"lat": 35.50043921530942,
							"lng": 23.57863594291497,
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Strände, NATURA-Gebiete",
							"text": "Falasarna ist ein berühmter Strand, der 17 km von Kasteli Kissamos entfernt liegt. Der zentrale, einen Kilometer lange Strand heißt Pahia Ammos und ist organisiert. Er hat einen hellen Sandstrand und türkisfarbenes Wasser. Es gibt einen weiteren, 800 Meter langen, ruhigeren Strand, in dessen Nähe sich die Kapelle von Agia Paraskevi und eine Quelle befinden. Im Norden befinden sich zwei weitere Strände, Livadi mit Felsen am Boden und der andere mit Kieselsteinen in der Nähe des Hafens. Das Gebiet wurde aufgrund der seltenen Flora und Fauna in das Natura 2000-Programm aufgenommen. Im nördlichen Teil des Strandes sind Ruinen des autonomen griechisch-römischen Stadt-Staates Falasarna erhalten, der am heutigen Standort Koutri existierte und eine eigene Währung hatte. Falasarna erhielt seinen Namen von der mythologischen Nymphe Falasarna und war der Hafen von Polyrrenia. Der Hafen war von Mauern umgeben und durch einen Kanal mit dem Meer verbunden. Es wird angenommen, dass Falasarna vom römischen Feldherrn Metellus wegen des Widerstands, den sie leisteten, zerstört wurde. Heute ist ein Teil der Stadt im Meer versunken und die Ruinen des Hafens befinden sich an Land, da die Küste auf etwa 6 Meter angehoben wurde, wahrscheinlich aufgrund des Erdbebens im Jahr 365 n. Chr.<p><strong><i>Zugang für Behinderte:</i></strong><br>Autobahn, Auf dem Seeweg</p><p><strong><i>Zugangsmittel:</i></strong><br>Nein</p>",
							"featured": 0
						})
					}	
					if (i18n.language == 'fr'){
						ListArray.push({
							"id": "1_358",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/f24e62b0f44950f0c8a4a06255374a3e2446e1d4.jpg",
							"municipality": "Κισσάμου",
							"title": "Tigani - Lagune de Balos",
							"lat": "35.58001516779292",
							"lng": "23.588629548652445",
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Plages, Zones NATURA",
							"text": "La lagune de Balos se trouve à l’extrémité nord-ouest de la Crète, à 17 kilomètres de Kasteli de Kissamos. Il s’agit d’une plage célèbre, d’une beauté exotique, qui accueille un grand nombre de visiteurs en été. L’eau de la mer forme une grande lagune, piégée entre les péninsules de Gramvoussa et de Tigani qui est liée au reste de la Crète par une fine bande de terre. La plage est faite de sable tout blanc qui, par endroits, est rose à cause des coquillages brisés. Les eaux turquoise sont très peu profondes, à l’exception de la partie droite où la profondeur augmente quelque peu. Balos relève du réseau des zones protégées Nature 2000, en raison de l’intérêt écologique qu’il présente. Sur les dunes de la plage, la végétation est particulière. On y trouve des bruyères, du thym, des lentisques, le lys de plage, l’espèce protégée de centaurée naine (Centaurea pumilio), etc. À Tigani, l’on trouve également du chardon-Marie. Pour accéder à la plage, une partie du trajet peut être faite en auto et, ensuite, en empruntant à pied un sentier qui se trouve sur les flancs du mont Geroskinos, sur la péninsule de Gramvoussa. Ce trajet vous permettra d’admirer et de photographier le paysage enchanteur qui s’étend devant vous. Un autre possibilité, pour accéder à la plage, est de prendre le petit bateau qui s’y rend depuis Kasteli.<p><strong><i>Accès handicapés: </i></strong><br>Marche à pied, Par mer</p><p><strong><i>Moyens d'accès: </i></strong><br>Non</p>",
							"featured": 1
						})
						ListArray.push({
							"id": "1_359",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/d633517c607fd2bd6bd443f9262a48145dd99241.jpg",
							"municipality": "Κισσάμου",
							"title": "Falassarna",
							"lat": 35.50043921530942,
							"lng": 23.57863594291497,
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Plages, Zones NATURA",
							"text": "Falassarna est une plage célèbre qui se trouve à une distance de 17 kilomètres de Kasteli de Kissamos. La plage centrale, qui s’étend sur un kilomètre, s’appelle Pachia Ammos et est organisée. Elle est couverte de sable clair et les eaux sont turquoise. Il existe également un autre plage, de 800 mètres de long, plus calme. Tout près, se trouvent la chapelle d’Agia Paraskevi et une source. Au nord, se trouvent deux autres plages : Livadi, dont le fond est semé de rochers, et une autre, couverte de galets fins, près du petit port. La région fait partie des zones protégées Nature 2000, en raison de la faune et de la flore rares. Dans la partie nord de la plage, se trouvent les vestiges de la cité-état autonome gréco-romaine de Falassarna qui se trouvait au lieu-dit Koutri. La cité frappait sa propre monnaie. Elle tire son nom de la nymphe Falassarni, et elle était le port de Polyrrinia. Le port était protégé par des murailles et il était lié à la mer au moyen d’un canal. Falassarna aurait été détruite par le général romain Metellus, en raison de la résistance des habitants. Actuellement, une partie de la cité est immergée dans la mer et les vestiges du port se trouvent sur terre ferme. en effet, en raison probablement du séisme de 365 ap. J.-C., la côté s’est relevée sur environ 6 mètres.<p><strong><i>Accès handicapés: </i></strong><br>Autoroute, Par mer</p><p><strong><i>Moyens d'accès: </i></strong><br>Non</p>",
							"featured": 0
						})
					}
					if (i18n.language == 'ru'){				
						ListArray.push({
							"id": "1_358",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/f24e62b0f44950f0c8a4a06255374a3e2446e1d4.jpg",
							"municipality": "Κισσάμου",
							"title": "Тигани - Лагуна на побережье Балос",
							"lat": "35.58001516779292",
							"lng": "23.588629548652445",
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Пляжи, ТЕРРИТОРИИ NATURA",
							"text": "Лагуна Балос расположена на северо-западной оконечности Крита, в 17 км от Кастели м-та Кисамос. Это знаменитый пляж экзотической красоты, с большим движением летом. Воды моря образуют крупную лагуну, поскольку они зажаты между полуостровом Грамвуса и полуостровом Тигани, соединённым с остальной частью Крита тонкой полоской суши. Пляж с белым песком и в некоторых местах розовым от разбитых раковин, в то время как бирюзовые воды очень мелки, за исключением правой части залива, где они несколько углубляются. Балос относится к сети охраняемых территорий Natura 2000 ввиду его экологической ценности. В песчаных дюнах пляжа есть особая растительность, такая как вереск, тимьян, фисташковые деревья, пляжные лилии, охраняемый вид центаврия, или нанодис и т.д. На п-ве Тигани также растёт чертополох. Добраться до пляжа можно до определенного места на машине, а затем пешком по тропинке, проходящей по склону горы Героскинос полуострова Грамвуса. Любой, кто совершит этот маршрут, будет иметь возможность насладиться великолепным пейзажем, раскинувшимся перед ним, и сфотографировать его. Кроме того, добраться дотуда можно на лодке из Кастели.<p><strong><i></i></strong><br>Пешком, По морю</p><p><strong><i></i></strong><br>Нет</p>",
							"featured": 1
						})
						ListArray.push({
							"id": "1_359",
							"image": "https://chaniaregion-admin.repository.gr/files/asset/d633517c607fd2bd6bd443f9262a48145dd99241.jpg",
							"municipality": "Κισσάμου",
							"title": "Фалассарна",
							"lat": 35.50043921530942,
							"lng": 23.57863594291497,
							"rate": 4.7,
							"vote": 1,
							"category_id": 22,
							"category": "Пляжи, ТЕРРИТОРИИ NATURA",
							"text": "Фаласарна - знаменитое побережье, расположенное в 17 км от Кастели м-та Кисамос. Центральный пляж длиной в один километр называется Пахиа Аммос, он является организованным. Здесь есть лёгкий песчаный пляж и бирюзовые воды. Ещё один пляж длиной 800 метров, более тихий, рядом с ним находится часовня Святой Параскевы и источник. Дальше к северу находятся два других пляжа: Ливади с камнями на морском дне и другой - с галькой - возле гавани. Этот район был включён в программу Natura 2000 ввиду своей редкой флоры и фауны. В северной части пляжа находятся руины автономного греко-римского города-государства Фаласарна, существовавшего на территории нынешнего Кутри, у которого была своя валюта. Фаласарна получила свое название от мифологической нимфы Фаласарни и была портом Полиринии. Порт был окружен стенами, а его связь с морем осуществлялась через канал. Считается, что Фаласарна была разрушена римским полководцем Метеллом из-за сопротивления, которое они оказали. Сегодня часть города погружена в море, а остатки порта находятся на суше, так как берег был поднят примерно на 6 метров, вероятно, из-за землетрясения, произошедшего в 365 г. после Р.Х.<p><strong><i></i></strong><br>Шоссе, По морю</p><p><strong><i></i></strong><br>Нет</p>",
							"featured": 0
						})
					}
				}
				

				list.map(item => (item.category_id === environmentSelected[0][i]) && ListArray.push(item))
			}
		}



		if (historySelected.length !== 0) {
			for (let i in historySelected[0]){
				list.map(item => (item.category_id === historySelected[0][i]) && ListArray.push(item))
			}
		}


		if (municipalitiesSelected.length !== 0) {

			if (environmentSelected.length == 0 && historySelected.length == 0)
					 ListArray = list

			for (let i in municipalitiesSelected[0]){
				ListArray.map(item => (item.municipality === municipalitiesSelected[0][i]) && ListArray2.push(item))
			}

			ListArray = ListArray2
		}

		if(selectSort == 'rate')
		ListArray = [...ListArray].sort((a, b) => a.rate > b.rate ? -1 : 1);






		return ListArray

  }


  static filterRoutesArray(list, routesSelected, municipalitiesSelected) {
	
		let ListArray = []
		let ListArray2 = []

		if (routesSelected.length == 0 && municipalitiesSelected.length == 0) {
			ListArray = list 
			return ListArray		
		}
		

		if (routesSelected[0]?.length == 0 && municipalitiesSelected[0]?.length == undefined) {
			ListArray = list 
			return ListArray		
		}



		if (routesSelected.length !== 0) {
			for (let i in routesSelected[0]){
				list.map(item => (item.extras._route_type.value[0] == routesSelected[0][i]) && ListArray.push(item))
			}
		}


		// if ( municipalitiesSelected.length !== 0) {

		// 	if (routesSelected.length == 0)
		// 		ListArray = list

		// 	if (municipalitiesSelected[0].length !== 0)
		// 		ListArray = ListArray.filter(item => { 

		// 			let q = item.place === municipalitiesSelected[0][0]
		// 			let w = item.place === municipalitiesSelected[0][1]
		// 			let e = item.place === municipalitiesSelected[0][2]
		// 			let r = item.place === municipalitiesSelected[0][3]
		// 			let t = item.place === municipalitiesSelected[0][4]
		// 			let y = item.place === municipalitiesSelected[0][5]
		// 			let u = item.place === municipalitiesSelected[0][6]
					
		// 			return ( q || w || e || r || t || y || u )
		// 		})
				
		// 	else {
		// 		return ListArray	
		// 	}	
				
		// }


		if (municipalitiesSelected.length !== 0) {

			if (routesSelected.length == 0 )
					 ListArray = list

			for (let i in municipalitiesSelected[0]){
				ListArray.map(item => (item.area_path[0][0] === municipalitiesSelected[0][i]) && ListArray2.push(item))
			}

			ListArray = ListArray2
		}

		return ListArray
  }











  static filterEventsArray(list, eventsSelected, datesSelected, municipalitiesSelected, dateRangeStartProp, dateRangeEndProp) {

		let ListArray = []
		let eventsArray = []

		if (eventsSelected.length == 0 && datesSelected.length == 0 &&  municipalitiesSelected.length == 0 ) {
			return list			
		}


		if (eventsSelected.length !== 0) {
			for (let i in eventsSelected[0]){
				list.map(item => (item.category_type === eventsSelected[0][i]) && ListArray.push(item))
			}
		}

		else {
			ListArray = list
		}



		if (datesSelected.length !== 0) {

			ListArray.map(item => {

				Date.prototype.addDays = function (days) {
					const date = new Date(this.valueOf());
					date.setDate(date.getDate() + days);
					return date;
				}
				
				let date = new Date();

				if (datesSelected[0] === 'today') {
					// console.log("------- TODAY -------")

					const dateSelected = returnDate(date.toLocaleString("el-GR"))

					for (let i = 0; i < item.time_periods.length; i++){
					
						const startDate = returnDate(item.time_periods[i].starting_date)
						const endDate = returnDate(item.time_periods[i].ending_date)

						item.time_periods[i].starting_date === '12/10/1983, 12:00' &&	eventsArray.push(item)
				
						if (dateSelected >= startDate && dateSelected <= endDate) {
							eventsArray.push(item);
						}
					}
				}

				if (datesSelected[0] === 'week') {
					// console.log("------- THIS WEEK -------")

					let WeekDay = date.getDay() //  1, 2, 3
					const dateFinishWeek = date.addDays(parseInt(7 - WeekDay))
					  
					const todayStart = returnDate(date.toLocaleString("el-GR"))
					const dateFinish = returnDate(dateFinishWeek.toLocaleString("el-GR"))
					
					for (let i = 0; i < item.time_periods.length; i++){
					
						const startDate = returnDate(item.time_periods[i].starting_date)
						const endDate = returnDate(item.time_periods[i].ending_date)
		
						item.time_periods[i].starting_date === '12/10/1983, 12:00' && eventsArray.push(item)

						if ( todayStart <= endDate && !( startDate >= dateFinish)) {
							eventsArray.push(item);
						}
					}
				}

				if (datesSelected[0] === 'month') {
					// console.log("------- THIS MONTH -------")
					let thisMonthDays = daysInMonth(date.getMonth(), date.getFullYear())
					let days = thisMonthDays - date.getDate()
					let lastDayOfMonth = date.addDays(parseInt(days)) 

					const today = date
					const todayStart = returnDate(today.toLocaleString("el-GR"))

					for (let i = 0; i < item.time_periods.length; i++){
					
						const startDate = returnDate(item.time_periods[i].starting_date)
						const endDate = returnDate(item.time_periods[i].ending_date)
		
						item.time_periods[i].starting_date === '12/10/1983, 12:00' && eventsArray.push(item)
				
						if ( todayStart <= endDate && !( startDate >= lastDayOfMonth)) {
							eventsArray.push(item)
						}
					}
				}


				if (datesSelected[0] === 'nextMonth') {
					// console.log("------- NEXT MONTH -------")
				
					let nextMonth = ''
					let nextNextMonth = ''
					date.getMonth() == 11 ? nextMonth = new Date(date.getFullYear() + 1, 0, 1) : nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1)
					date.getMonth() == 11 ? nextNextMonth = new Date(date.getFullYear() + 1, 0, 1) : nextNextMonth = new Date(date.getFullYear(), date.getMonth() + 2, 1)

					for (let i = 0; i < item.time_periods.length; i++){
					
						const startDate = returnDate(item.time_periods[i].starting_date)
						const endDate = returnDate(item.time_periods[i].ending_date)

						item.time_periods[i].starting_date === '12/10/1983, 12:00' && eventsArray.push(item)

						if ( (nextMonth <= endDate && nextMonth >= startDate) || (nextNextMonth >= endDate && nextNextMonth >= startDate && nextMonth <= endDate)) {
							eventsArray.push(item)
						}

					}
				}


				if (datesSelected[0] === 'range'){
					// console.log("------- RANGE -------")

					for (let i = 0; i < item.time_periods.length; i++){
					
						const startDate = returnDate(item.time_periods[i].starting_date)
						const endDate = returnDate(item.time_periods[i].ending_date)

						item.time_periods[i].starting_date === '12/10/1983, 12:00' && eventsArray.push(item)
				
						if (((startDate <= dateRangeStartProp && dateRangeStartProp <= endDate) || (startDate <= dateRangeEndProp && dateRangeEndProp <= endDate)) ||
							(dateRangeStartProp <= startDate && endDate <= dateRangeEndProp) || (dateRangeStartProp === startDate && endDate === dateRangeEndProp) ) {
							eventsArray.push(item)
							continue;
						}
					}
				}

			})

			ListArray = eventsArray
		}


		if (municipalitiesSelected.length !== 0) {

			if (municipalitiesSelected[0].length !== 0)
			{
				
				ListArray = ListArray.filter(item => {

					let q = item.place === municipalitiesSelected[0][0]
					let w = item.place === municipalitiesSelected[0][1]
					let e = item.place === municipalitiesSelected[0][2]
					let r = item.place === municipalitiesSelected[0][3]
					let t = item.place === municipalitiesSelected[0][4]
					let y = item.place === municipalitiesSelected[0][5]
					let u = item.place === municipalitiesSelected[0][6]
					
					return (q || w || e || r || t || y || u)
				})
				
			}
				
		}

		else {
			return ListArray
		}

		return ListArray
  }






  static filterFavoritePoisesArray(list, municipalitiesSelected) {
	
		let ListArray = []

		if ( municipalitiesSelected.length == 0) {
			ListArray = list
		}

		if (municipalitiesSelected.length !== 0) {
			for (let i in municipalitiesSelected) {
				list.map(item => (item.municipality === municipalitiesSelected[i]) && ListArray.push(item))
			}
		}

		return ListArray
  }
	














	
  static filterRoutesIdPopiline(list, idPopiline) {
	
		let data = list.filter(item => {

			return item['id'] === idPopiline
		})

		return data
	}



  static filterPoints(list, North, East, South, West ) {
	
		let data = list.filter(item => {

			let array_North = (item.lat < North) 
			let array_East = (item.lng < East) 
			let array_South = (item.lat > South) 
			let array_West = (item.lng > West) 

			return ( array_North && array_East && array_South && array_West )
		})
		return data
	}



	static FilterRoutes(Routes, regionsSelected, routesSelected ) {
	
		let regionsArray = []
		let routesArray = []

		// For Route Page
		if (regionsSelected.length === 0 && routesSelected.length === 0) {
			return Routes
		}
		else if (regionsSelected.length === 0 && routesSelected.length != 0) {
			for (const route in routesSelected){
				Routes.map(item => (item.route_type === routesSelected[route]) && routesArray.push(item))
			}
			return routesArray
		}

		else {

			for (const region in regionsSelected){
				Routes.map(item => (item.municipality === regionsSelected[region]) &&	regionsArray.push(item))
			}

			for (const route in routesSelected){
				regionsArray.map(item => (item.route_type === routesSelected[route]) && routesArray.push(item))
			}

			return routesArray
		}

	}

	
  static MapFilterRoutes(Routes, regionsSelected, routesSelected, check ) {
	
		let regionsArray = []
		let routesArray = []

		if (check)
			return Routes
		
		else {
						for (const region in regionsSelected){
						Routes.map(item => (item.municipality === regionsSelected[region]) &&	regionsArray.push(item))
					}

						for (const route in routesSelected){
						regionsArray.map(item => (item.route_type === routesSelected[route]) && routesArray.push(item))
					}

			return routesArray
		}
		
	}



  static MapFilterEvents(Events, regionsSelected, optionsSelected, daySelected ) {
	
		let regionsArray = []
		let optionsArray = []
		let eventsArray = []

		for (const region in regionsSelected) {
			Events.map(item => (item.municipality === regionsSelected[region]) &&	regionsArray.push(item))
		}

		for (const option in optionsSelected) {
			regionsArray.map(item => (item.category_type === optionsSelected[option]) && optionsArray.push(item))
		}


		optionsArray.map(item => {

			Date.prototype.addDays = function (days) {
				const date = new Date(this.valueOf());
				date.setDate(date.getDate() + days);
				return date;
			}
			
			let date = new Date();
			date = date.addDays(parseInt(daySelected))
      const dateSelected = returnDate(date.toLocaleString())


			if (daySelected == '40'){
				eventsArray = optionsArray
			} else {

				for (let i = 0; i < item.time_periods.length; i++){
				
					const startDate = returnDate(item.time_periods[i].starting_date)
					const endDate = returnDate(item.time_periods[i].ending_date)
	
					if (item.time_periods[i].starting_date == '12/10/1983, 12:00'){
						eventsArray.push(item)
						continue;
					}
			
					if (dateSelected > startDate && dateSelected < endDate) {
						eventsArray.push(item);
						continue;
					}
				}
			}

		})



			// const dateSelected = returnDate(date.toLocaleString())
			// const startDate = returnDate(item.time_periods[0].starting_date)
			// const endDate = returnDate(item.time_periods[0].ending_date)

			// if (item.time_periods[0].starting_date == '12/10/1983, 12:00' || daySelected == '40')
			// 	  eventsArray.push(item)
			// else {
			// 	if (dateSelected > startDate && dateSelected < endDate)
			// 		eventsArray.push(item)	
			// }

		
			// return null
		// })

		return eventsArray
	}

}


function returnDate(Str) {

	const [StrDay, StrHour ] = Str.split(',')
	const [day, month, year] = StrDay.split('/')
	const date = new Date(+year, month - 1, +day)

	return date
}
	
function daysInMonth (month, year) {
	return new Date(year, month, 0).getDate();
}


export default Utils